import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getEvidenceReview = async (token, params) => {
  const url = `municipalities/${params.municipality_id}/monitoring/evidence_review`
  return apiGet({ url, token, params })
}

export default function useEvidenceReview({ transactionId, analyticId, options = {} }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)
  const params = { municipality_id, transaction_id: transactionId, analytic_id: analyticId }

  return useQuery(
    ['monitoring-evidence-review', params],
    () => getEvidenceReview(token, params),
    { enabled: Boolean(transactionId && analyticId), ...options }
  )
}
